<template>
  <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10 mt-1">
    <cleave
      :ref="refName"
      :options="cleaveOptions"
      class="ant-input"
      :raw="raw"
      :style="inputStyle"
      v-model="inputValue"
      :placeholder="generatedPlaceholder"
    />
  </div>
</template>

<script>
import Cleave from 'vue-cleave-component'
export default {
  components: {
    cleave: Cleave,
  },
  name: 'FormNumber',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    refName: {
      type: String,
      default: 'cleave',
    },
    placeholder: {
      type: String,
      default: null,
    },
    cleaveOptions: {
      type: Object,
      default: () => ({ numeral: true }),
    },
    raw: {
      type: Boolean,
      default: true,
    },
    width: {
      type: [String, Number],
      default: '200px',
    },
    align: {
      type: String,
      default: 'right',
    },
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    generatedPlaceholder() {
      return this.placeholder || `Masukan ${this.refName.charAt(0).toUpperCase() + this.refName.slice(1)}`
    },
    inputStyle() {
      return {
        'text-align': this.align,
        width: typeof this.width === 'number' ? `${this.width}px` : this.width,
      }
    },
  },
}
</script>
